import { render } from "./ViewTrade.vue?vue&type=template&id=0dc958ba"
import script from "./ViewTrade.vue?vue&type=script&lang=js"
export * from "./ViewTrade.vue?vue&type=script&lang=js"
script.render = render

export default script